export default function BeforeAfter() {
  const rows = [
    {
      objection: '«Дорого»',
      before: { text: 'Сразу предлагает скидку', desc: 'Начинает оправдываться и торговаться, не выяснив, с чем клиент сравнивает цену.' },
      after: { text: 'Продаёт ценность', desc: 'Уточняет критерии выбора, помогает увидеть разницу результата и стоимость владения.' },
    },
    {
      objection: '«Нам нужно подумать»',
      before: { text: 'Прощается и ждёт', desc: 'Разговор заканчивается без следующего шага — клиент уходит «в туман».' },
      after: { text: 'Договаривается о шаге', desc: 'Фиксирует конкретную дату и повод для следующего контакта.' },
    },
    {
      objection: '«Работаем с другими»',
      before: { text: 'Критикует конкурента', desc: 'Сравнивает в лоб и вызывает у клиента защитную реакцию.' },
      after: { text: 'Выясняет критерии', desc: 'Понимает, что важно клиенту, и позиционирует предложение по этим критериям.' },
    },
    {
      objection: '«Пришлите предложение»',
      before: { text: 'Отправляет КП', desc: 'Клиент получает файл и пропадает — контакт потерян.' },
      after: { text: 'Сначала выявляет задачу', desc: 'Собирает потребность до КП и назначает разбор коммерческого предложения.' },
    },
    {
      objection: '«Нет бюджета»',
      before: { text: 'Соглашается с отказом', desc: 'Считает, что «не по карману», и завершает разговор.' },
      after: { text: 'Пересобирает решение', desc: 'Подбирает формат под бюджет клиента без потери ценности предложения.' },
    },
    {
      objection: '«Позвоните позже»',
      before: { text: 'Звонит наугад', desc: 'Повторные попытки без повода — клиент перестаёт отвечать.' },
      after: { text: 'Создаёт повод', desc: 'Договаривается о дате и приносит клиенту новую пользу к следующему контакту.' },
    },
  ];

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="before-after" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Возражения: до и после обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Одно и то же возражение клиента — два разных результата. Слева — как реагирует неподготовленный менеджер. Справа — как работает обученная команда.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white">
            {/* Header */}
            <div className="grid grid-cols-2 bg-gray-100">
              <div className="p-4 md:p-6 text-center border-r border-gray-200">
                <div className="flex items-center justify-center gap-2 text-red-600 font-bold text-base md:text-lg">
                  <i className="ri-close-circle-line text-xl"></i>
                  До обучения
                </div>
              </div>
              <div className="p-4 md:p-6 text-center">
                <div className="flex items-center justify-center gap-2 text-teal-600 font-bold text-base md:text-lg">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                  После обучения
                </div>
              </div>
            </div>

            {/* Rows */}
            {rows.map((row, i) => (
              <div key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}>
                <div className="px-4 md:px-6 pt-4 md:pt-5">
                  <span className="inline-flex items-center gap-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-semibold px-3 py-1 rounded-full">
                    <i className="ri-chat-quote-line text-teal-600"></i>
                    Возражение {row.objection}
                  </span>
                </div>
                <div className="grid grid-cols-2">
                  <div className="p-4 md:p-6 border-r border-gray-100 flex items-start gap-3">
                    <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-close-line text-red-500 text-sm"></i>
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm md:text-base mb-1">{row.before.text}</div>
                      <div className="text-gray-500 text-xs md:text-sm leading-relaxed">{row.before.desc}</div>
                    </div>
                  </div>
                  <div className="p-4 md:p-6 flex items-start gap-3">
                    <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-teal-600 text-sm"></i>
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm md:text-base mb-1">{row.after.text}</div>
                      <div className="text-gray-500 text-xs md:text-sm leading-relaxed">{row.after.desc}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Metric strip */}
          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            <div className="bg-white rounded-xl p-5 text-center border border-gray-100">
              <div className="text-2xl md:text-3xl font-extrabold text-teal-600 mb-1">18–55%</div>
              <p className="text-xs md:text-sm text-gray-600">рост конверсии в реальных проектах после обучения работе с возражениями</p>
            </div>
            <div className="bg-white rounded-xl p-5 text-center border border-gray-100">
              <div className="text-2xl md:text-3xl font-extrabold text-teal-600 mb-1">меньше скидок</div>
              <p className="text-xs md:text-sm text-gray-600">сделки перестают уходить в скидку на первом же «дорого»</p>
            </div>
            <div className="bg-white rounded-xl p-5 text-center border border-gray-100">
              <div className="text-2xl md:text-3xl font-extrabold text-teal-600 mb-1">больше повторных</div>
              <p className="text-xs md:text-sm text-gray-600">клиенты возвращаются, потому что возражения решаются, а не игнорируются</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обучить команду работе с возражениями
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}